import { createPlacementFrontend } from '../frontend/create-placement-frontend';

import { createPlacementBackend } from './backend-factory';
import type {
	AnyFrontendStages,
	AnyProps,
	DefaultFrontendStages,
	NoProps,
	PlacementMessageFrontendFactory,
	PlacementRenderer,
} from './frontend-types';
import type {
	AnyBackendMessageStages,
	DefaultBackendMessageStages,
	PlacementBackend,
	PlacementBackendFactory,
	PlacementMessageBackendFactory,
} from './backend-types';
import type { PlacementConfig, PlacementDefinition } from './shared-types';

type AnyCreatePlacementDefinition = PlacementDefinition<{
	backend: AnyBackendMessageStages;
	frontend: AnyFrontendStages;
}>;

type DefaultCreatePlacementDefinition = PlacementDefinition<{
	backend: DefaultBackendMessageStages;
	frontend: DefaultFrontendStages;
}>;

export const createPlacement = <
	T extends AnyCreatePlacementDefinition = DefaultCreatePlacementDefinition,
>(
	placementConfig: PlacementConfig,
): {
	createFrontend: <U extends AnyProps = NoProps>(
		placementRenderer: PlacementRenderer<T['frontend'], U>,
	) => PlacementMessageFrontendFactory<T['frontend'], U>;
	createBackend: (
		placementBackendParams?: PlacementBackend<T['backend']> | undefined,
	) => PlacementMessageBackendFactory<T['backend']>;
} => {
	return {
		createFrontend: createPlacementFrontend<T['frontend']>(placementConfig),
		createBackend: createPlacementBackend<T['backend']>(placementConfig),
	};
};

export {
	createBackendPlacementMessageTemplateRouter,
	createBackendPlacementRunners,
	createPlacementBackend,
	createPlacementMessageBackend,
} from './backend-factory';

export type { PlacementBackendFactory };
